<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
  html, body, #app {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    min-width: 1000px;
    min-height: 594px;
    -webkit-font-smoothing: antialiased;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei",SimSun,sans-serif;
    font-size: 14px;
    color: #1F2D3D;
    background-color: #FFF;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue